import useLocations from "../../data/useLocations";
import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IVehicle } from "../../models/Vehicle";
import ComboBoxInput from "../shared/Inputs/ComboBoxInput";

export default function VehicleLocationDropdown({ vehicle, classes = "", size = "md" }: { vehicle: IVehicle | undefined, classes?: string, size?: "sm" | "md" | "lg" }) {
  const { locations } = useLocations();
  const { patchVehicle } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Vehicle Location");
  const locationOptions = [{ id: "", name: "No Location" }, ...(locations.data?.data ?? [])];

  const handleLocationUpdate = (locationId: string) => {
    if (!vehicle) return;

    patchVehicle.mutate(
      { vehicleId: vehicle.id, patch: { locationId: locationId || null, updateLocationId: true } },
      {
        onSuccess: () => saveHandlers.onSuccess(),
        onError: () => saveHandlers.onError(),
      }
    );
  }

  const handleSetValue = (_registerName: string, value: string) => {
    if (!vehicle) return;

    const nextLocationId = value ? value : null;
    if (vehicle.locationId === nextLocationId) return;

    handleLocationUpdate(value);
  };

  if (locations.isLoading || !vehicle) {
    return <></>
  }

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      <ComboBoxInput
        key={`vehicle-location-${vehicle.id}-${vehicle.locationId ?? "none"}`}
        options={locationOptions}
        searchField={"name"}
        valueField={"id"}
        registerName={"locationId"}
        setValue={handleSetValue}
        register={null}
        initialValue={vehicle.locationId ?? ""}
        placeholder="Search for a Yard Location"
        classes={classes}
        containerClasses="w-full"
        size={size}
      />
    </div>
  )
}
